if($('.in-index').length){
    $('.middle-banners-wrapper').insertAfter('.homepage-products-2');
    setTimeout(function(){
        $('.ratings-block').insertBefore('.products-group');
        $('.top-category-block').insertBefore('.products-group');
        
    }, 500)
    
}